<div class="REF-enjyapp-mwrp">
    <a class="link UNFAPP-crossbtn-cont" mat-dialog-close ><img src="assets/img/filter-close-icon.png" class="icon UNFAPP-crossbtn-img" /></a>
    <h3 class="REF-enjyapp-heading UNFAPP-m-hide">Enjoying our app?</h3>

    <div class="REF-invite-img-holder REF-grd-m-imgcont UNFAPP-d-hide">
        <img src="assets/img/invite-earn.svg" alt="" class="REF-invite-img"/>
    </div>

    <h3 class="REF-enjyapp-heading UNFAPP-d-hide">Enjoying Infinity Learn?</h3>
    <p class="REF-mob-subtext UNFAPP-d-hide">
        Now you can Invite your friends and Earn exciting Rewards!
    </p>
    <div class="UNFAPP-enjytextndimgwpr UNFAPP-m-hide">
        <div class="REF-invite-img-holder">
            <img src="assets/img/invite-earn.svg" alt="" class="REF-invite-img"/>
        </div>
        <p class="REF-texthold">
            Now you can Invite your friends and Earn exciting Rewards!
        </p>
    </div>
    <div class="REF-copy-wrpmain">
        <button class="REF-copy-linkbtn" (click)="copyRefCode()">
            <img src="assets/img/CYOT-copy-blue.svg" alt="" class="REF-copyimg-btn" />
            Copy referral link
        </button>
        <button class="REF-sh-socimg-h"  mat-fab  [url]="referralObj?.deepLink"  shareButton="whatsapp" (click)="sendNdNavigate('whatsapp')" >
            <div class="REF-sh-icon-outer">
                <i class="fab fa-whatsapp REF-sh-whatsapp-ic"></i>
            </div>                            
            </button>
        <!-- <a href="#" class="REF-watsapp-ic"><img src="assets/img/CYOT-whatsapp.png" alt="" /></a> -->
        <!-- <a href="#" class=""><img src="assets/img/CYOT-share-blueicon.svg" alt="" class="REF-share-ic"/></a> -->
        <button (click)="shareSocialdialog()" class="REF-share-ic" mat-dialog-close><img src="assets/img/CYOT-share-blueicon.svg" alt="" /></button>
    </div>
</div>
